export const RECIPE_TRANSLATION_ICONS_PATH = 'assets/images/recipe-translation';
